module.exports = __webpack_public_path__ + "static/media/image4.d242a2bd.jpg";